import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const companyRouter: Array<RouteRecordRaw> = [
    {
        path: '/company',
        name: '公司管理',
        component: Layout,
        redirect: '/company/list',
        meta: { title: '公司管理', icon: 'icon-company', alwaysShow: true },
        children: [
            {
                path: 'list',
                name: '公司列表',
                component: () => import('@/views/company/List.vue'),
                meta: { title: '公司列表' , keepAlive: true, depth: 30}
            },
            {
                path: 'edit',
                name: '公司编辑',
                component: () => import('@/views/company/Edit.vue'),
                meta: { title: '公司编辑', hidden: true }
            }
        ]
    }
]

export default companyRouter